import { CopyOutlined } from '@ant-design/icons';
import 'animate.css/animate.css';
import axios from 'axios';
import { useState } from 'react';
import { GET_PRESIGNED_URL } from '../../services';
import '../../toastr.min.css';
import CustomButton from '../Button';
import customTost from '../Notification';

const ExportLogsButton = () => {
	const [exportState, setExportState] = useState(false);
	const [logsState, setLogsState] = useState(false);
	const [exportUrl, setExportUrl] = useState('');

	const getPresignedUrl = async () => {
		try {
			const { data } = await GET_PRESIGNED_URL({
				fileName: 'logs.zip',
				bucketName: 'system-files',
			});
			if (data && data.url) {
				setExportUrl(data.url);
				setLogsState(true);
				setExportState(false);
			}
		} catch (err) {
			console.error(err);
			setExportState(false);
		}
	};

	const handleExportClick = () => {
		try {
			setExportState(true);
			axios
				.get(`/api/get-pod-logs`)
				.then((res) => {
					if (res) {
						getPresignedUrl();
					}
				})
				.catch((err) => {
					console.error(err);
					customTost({
						type: 'error',
						message: 'Something went wrong. Please try after sometime.',
					});
					setExportState(false);
				});
		} catch (err) {
			console.error(err);
			customTost({
				type: 'error',
				message: 'Something went wrong. Please try after sometime.',
			});
			setExportState(false);
		}
	};
	const downloadLogs = () => {
		setLogsState(false);
	};

	return (
		<>
			{!exportState ? (
				<>
					{logsState ? (
						<a className='btnExport downloadLogs' onClick={downloadLogs} href={exportUrl}>
							<CopyOutlined /> Download Logs
						</a>
					) : (
						<CustomButton
							className='btnExport'
							type='primary'
							size='middle'
							onClick={handleExportClick}
							icon={<CopyOutlined />}
						>
							{'Export Logs'}
						</CustomButton>
					)}
				</>
			) : (
				<CustomButton className='btnExport' type='primary' size='middle' isLoading={exportState}>
					{'Generating Logs...'}
				</CustomButton>
			)}
		</>
	);
};

export default ExportLogsButton;
